angular.module("vgresiduos").controller("DisposalTechCtrl", [
	"$scope",
	"$rootScope",
	"$q",
	"httpService",
	"disposalService",
	function ($scope, $rootScope, $q, httpService, disposalService) {
		"use strict";

		$scope.labels = $rootScope.labels;
		let isListLoaded;

		this.$onInit = function () {
			loadDisposalTechnologies().then(setDisposalTech);
		};

		function loadDisposalTechnologies() {
			const deferred = $q.defer();

			if (isListLoaded) {
				deferred.resolve();
				return deferred.promise;
			}

			httpService.getListFromServiceCore(disposalService.listDisposalTypes, null).then(
				function (response) {
					$scope.disposalTechnologies = response.list.map((d) => {
						return {
							Id: d.id,
							Description: d.description,
							Ibama: d.ibama ? { Id: d.ibama.id, Description: d.ibama.description } : null
						};
					});
					isListLoaded = true;
					deferred.resolve();
				},
				function () {
					deferred.reject();
				}
			);

			return deferred.promise;
		}

		function setDisposalTech() {
			if (!$scope.$ctrl.setterId) {
				$scope.$ctrl.model = null;
				return;
			}

			const foundDisposalTech = $scope.disposalTechnologies.find(
				(disposalTech) => disposalTech.Id == $scope.$ctrl.setterId
			);
			if (foundDisposalTech != null) {
				$scope.$ctrl.model = foundDisposalTech;
			} else {
				getDisposalTech();
			}
		}

		function getDisposalTech() {}

		const watchModel = $scope.$watch("$ctrl.model", function (newValue, oldValue) {
			if (newValue != oldValue && $scope.$ctrl.onDisposalTechChanged) {
				$scope.$ctrl.onDisposalTechChanged(newValue);
			}
		});

		const watchSetterId = $scope.$watch("$ctrl.setterId", function (newValue, _oldValue) {
			const modelId = $scope.$ctrl.model ? $scope.$ctrl.model.Id : null;

			if (newValue != modelId) {
				loadDisposalTechnologies().then(setDisposalTech);
			}
		});

		$scope.$on("$destroy", function () {
			// disable the listener
			watchModel();
			watchSetterId();

			// nullify the DOM-bound model
			$scope.domElement = null;
		});

		$scope.getLabel = function () {
			if ($scope.$ctrl.noLabel) {
				return "";
			}

			return $scope.$ctrl.label ? $scope.$ctrl.label : $scope.labels.DISPOSAL_TECH;
		};
	}
]);
